import React, { useContext } from 'react';
import Register from './components/Register';
import Login from './components/Login';
import ChatHome from './chats/ChatHome';
import Home from './components/Home';

import { BrowserRouter,Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from './context/AuthContext';
import Buschedule from './components/Buschedule';


function App() {

  const {currentUser} = useContext(AuthContext);
  const ProtectedRoute = ({children}) =>{ 
    if(!currentUser){
      return <Navigate to ="/login"/>
    }
    return children
  }
  
  return (
    <BrowserRouter>
        <Routes>
          <Route path='/'>
            <Route index element={<Home />
              }/>
            <Route path='login' element={<Login/>}/>
            <Route path='register' element={<Register />}/>
            <Route path='buschedule' element={<Buschedule/>}/>
            <Route path='chathome' element={
              <ProtectedRoute>
                <ChatHome />
              </ProtectedRoute>}/>
          </Route>
        </Routes>
      </BrowserRouter>
  );
}


export default App;
